import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

// Services
import { UserStaffService } from '../../../../../Services/User/Staff/user-staff.service';
import { NotificationService } from '../../../../../Services/notification.service';
import { UserAccessService } from '../../../../../Services/UserAccess/user-access.service';

interface MenuOption {
  lable: string;
  path: string;
  visible: boolean;
  submenu?: MenuOption[];
  key?: string;
  //  NEW
  updatePermission?: string;
  deletePermission?: string;
}

@Component({
  selector: 'app-admin-access-control',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './admin-access-control.component.html',
})
export class AdminAccessControlComponent implements OnInit {

  activeUserId: number | null = null;
  activeUserName: string | null = null;
  activeUserImage: string | null = null;
  activeUserLastName: string | null = null;
  isLoading = false;

  selectedMainPaths: string[] = [];
  selectedSubPaths: string[] = [];
  selectedUpdatePaths: string[] = [];
  selectedDeletePaths: string[] = [];

  activeMenuIndex: number = 0;
  showMobileDetails: boolean = false;

  // Your existing Navbar Options...
  navbarOptions: MenuOption[] = [
    {
      lable: 'Home',
      path: '/home',
      visible: true,
      submenu: [
        { path: '/accounts', lable: 'Accounts', visible: true, updatePermission: 'accounts_update', deletePermission: 'accounts_delete' },
        { path: '/account-ledger', lable: 'Account Ledger', visible: true },
        { path: '/daybook', lable: 'Daybook', visible: true },
        { path: '/profit-loss', lable: 'Profit & Loss', visible: true },
        { path: '/trail-balance', lable: 'Trail Balance', visible: true },
        { path: '/balance-sheet', lable: 'Balance Sheet', visible: true },
        { path: '/udhar-list', lable: 'Udhar list', visible: true },

      ]
    },
    // {
    //   lable: 'Accounts',
    //   path: '/accounts',
    //   visible: true,
    //   submenu: [
    //     { path: '/accounts', lable: 'Accounts List', visible: true },
    //     { path: '/accounts/add-new-account', lable: 'Add New Account', visible: true },
    //     { path: '/accounts/update-all-accounts', lable: 'Update All Accounts', visible: true },
    //     { path: '/accounts/user-accounts', lable: 'User Accounts', visible: true },
    //     { path: '/accounts/account-balance', lable: 'Account Balance', visible: true },
    //   ]
    // },
    {
      lable: 'Staff Dashboard',
      path: '/rm-portal/home',
      visible: true,
      submenu: []
    },
    {
      path: '/add-ready-product',
      lable: 'Ready Product Line',
      visible: true,
      submenu: [
        { path: '/add-ready-product/piece', lable: 'Piece', visible: true },
        { path: '/add-ready-product/lot', lable: 'Lot', visible: true },
        { path: '/add-ready-product/non-jewellery-product', lable: 'Product', visible: true },
      ]
    },
    {
      path: '/raw-metal/metal',
      lable: 'Assembly Line',
      visible: true,
      submenu: [
        { path: '/product-creation', lable: 'Create Product', visible: true },
        { path: '/raw-metal/metal', lable: 'Add Raw Material', visible: true },
        { path: '/raw-metal/stone', lable: 'Stone', visible: true },
        // { path: '/raw-metal/metal', lable: 'Metal', visible: true },
        { path: '/order/order-creation', lable: 'Order Creation', visible: true },
        { path: '/design-product', lable: 'Designed Product List', visible: true },
        { path: '/available-to-produce', lable: 'Available To Produce (ATP)', visible: true },
        { path: '/material-requirement-sheet', lable: 'Material Requirement Sheet (MRS)', visible: true },
        { path: '/combo-creation', lable: 'Combo Creation', visible: true },
      ]
    },
    {
      path: '/packaging-form',
      lable: 'Packaging',
      visible: true,
      submenu: [
        {
          path: '/packaging-form',
          lable: 'New Packaging Entry',
          visible: true,
          updatePermission: 'stocks_update',
          deletePermission: 'stocks_delete'
        },
        {
          path: '/packaging-stack-form',
          lable: 'Create Packaging Stack',
          visible: true,
          updatePermission: 'stocks_update',
          deletePermission: 'stocks_delete'
        },
      ]
    },
    {
      path: '/product-tagging',
      lable: 'Tag',
      visible: true,
      submenu: [
        { path: '/product-tagging', lable: 'Product Tagging', visible: true },
        { path: '/taggings-list', lable: 'Taggings list', visible: true, key: 'taggings_list', deletePermission: 'stock_details_delete' },
        { path: '/tag-labels', lable: 'Tag Label', visible: true },
      ]
    },
    {
      path: '/report',
      lable: 'Report',
      visible: true,

      submenu: [

        {
          path: '/report/fine-jewellery',
          lable: 'Fine Jewellery',
          visible: true,
          key: 'fine_jewellery'
        },

        {
          path: '/report/imitation-jewellery',
          lable: 'Imitation Jewellery',
          visible: true,
          key: 'imitation_jewelry'
        },

        // =========================
        // ASSEMBLY STOCK
        // =========================

        {
          path: '/report/general-list',
          lable: 'Assembly Line Stock',
          visible: true,
          key: 'assembly_product',

          updatePermission: 'assembly_stock_update',
          deletePermission: 'assembly_stock_delete'
        },

        {
          path: '/report/assemblystock-list',
          lable: 'Assembly Product',
          visible: true,
          key: 'assembly_product',

          updatePermission: 'assembly_product_update',
          deletePermission: 'assembly_product_delete'
        },

        // =========================
        // RAW METAL
        // =========================

        // {
        //   path: '/report/raw-metal',
        //   lable: 'Raw Metal',
        //   visible: true,
        //   key: 'raw_metal',

        //   updatePermission: 'stocks_update',
        //   deletePermission: 'stocks_delete'
        // },

        {
          path: '/report/raw-metal-stock',
          lable: 'Raw Metal',
          visible: true,
          key: 'raw_metal_stock',

          updatePermission: 'stocks_update',
          deletePermission: 'stocks_delete'
        },

        // =========================
        // RAW STONE
        // =========================

        {
          path: '/report/raw-stone-stock-list',
          lable: 'Raw Stone',
          visible: true,
          key: 'stone_stock',

          updatePermission: 'stocks_update',
          deletePermission: 'stocks_delete'
        },

        {
          path: '/report/stock-tally',
          lable: 'Stock Tally',
          visible: false,
          key: 'stock_tally'
        },

        // =========================
        // READY PRODUCTS
        // =========================

        {
          path: '/report/ready-products',
          lable: 'Ready Product List',
          visible: true,
          key: 'ready_product_stock',

          updatePermission: 'ready_product_update',
          deletePermission: 'ready_product_delete'
        },

        {
          path: '/report/ready-products/piece',
          lable: 'Ready Piece Wise',
          visible: true,
          key: 'ready_product_stock',

          updatePermission: 'ready_product_piece_update',
          deletePermission: 'ready_product_piece_delete'
        },

        {
          path: '/report/ready-products/lot',
          lable: 'Ready Lot Wise',
          visible: true,
          key: 'ready_product_stock',

          updatePermission: 'ready_product_lot_update',
          deletePermission: 'ready_product_lot_delete'
        },

        {
          path: '/report/non-jewellery-product-list',
          lable: 'Other Products',
          visible: true,
          key: 'ready_product_stock',

          updatePermission: 'other_product_update',
          deletePermission: 'other_product_delete'
        },

        // =========================
        // OTHER REPORTS
        // =========================

        {
          path: '/report/reorder-list',
          lable: 'Re-Order List',
          visible: false,
          key: 'reorder_list'
        },

        {
          path: '/report/stock-ins',
          lable: 'Stocks IN',
          visible: true,
          key: 'stock_ins'
        },

        {
          path: '/report/stock-outs',
          lable: 'Stocks OUT',
          visible: true,
          key: 'stock_outs'
        },

        {
          path: '/report/stock-list',
          lable: 'Stocks List',
          visible: true,
          key: 'stock_list'
        },

        {
          path: '/report/other-panel',
          lable: 'Other Panel',
          visible: true,
          key: 'other_panel'
        },

        // =========================
        // PACKAGING
        // =========================

        {
          path: '/report/stock-packaging-list',
          lable: 'Stock Packaging list',
          visible: true,
          key: 'stock_packaging_list',

          updatePermission: 'stocks_update',
          deletePermission: 'stocks_delete'
        },

        {
          path: '/report/packaging-stack-list',
          lable: 'Packaging Stack list',
          visible: true,
          key: 'stock_packaging_list',

          updatePermission: 'stocks_update',
          deletePermission: 'stocks_delete'
        },

        {
          path: '/invoice-report',
          lable: 'Sell Invoice Report',
          visible: true,
          key: 'sell_invoice_report'
        }

      ]
    },
    // { path: '/rm-portal', lable: 'Sales Executive', visible: true, submenu: [] },
    // { path: '/#scheme', lable: 'Scheme', visible: false, submenu: [] },
    // { path: '/#loan', lable: 'Loan', visible: false, submenu: [] },
    // { path: '/#crdr', lable: 'Cr/Dr', visible: false, submenu: [] },
    // { path: '/#expense', lable: 'Expense', visible: false, submenu: [] },
    {
      path: '/user-list',
      lable: 'User List',
      visible: true,
      submenu: [
        { path: '/create-user/add-customer', lable: 'Add Customer', visible: true },
        { path: '/user-list/customer-list', lable: 'Customer List', visible: true, updatePermission: 'users_list_update', deletePermission: 'users_list_delete' },
        { path: '/create-user/add-staff', lable: 'Add Staff', visible: true },
        { path: '/user-list/staff-list', lable: 'Staff List', visible: true, updatePermission: 'user_staff_update', deletePermission: 'user_staff_delete' },
        { path: '/create-user/add-supplier', lable: 'Add Supplier', visible: true },
        { path: '/user-list/supplier-list', lable: 'Supplier List', visible: true, updatePermission: 'user_supplier_update', deletePermission: 'user_supplier_delete' },
        { path: '/create-user/add-investor', lable: 'Add Investor', visible: true },
        { path: '/user-list/investor-list', lable: 'Investor List', visible: true, updatePermission: 'investors_update', deletePermission: 'investors_delete' },
      ]
    },
    {
      lable: 'Sell',
      path: '/rm-portal/sell-customer',
      visible: true,
      submenu: [
        { lable: 'Sell permission *', path: '/sell-details-lot', visible: true },
        { lable: 'Payment panel *', path: '/payment-details', visible: true, deletePermission: 'stock_outs_delete' },
        { lable: 'Invoice *', path: '/invoice-b2b', visible: true },
        { lable: 'Invoice Panel *', path: '/invoice-panel', visible: true },
        { lable: 'Rough Estimate *', path: '/rough-estimate-invoice', visible: true },
      ]
    },
    {
      lable: 'Stock',
      path: 'rm-portal/new-stock',
      visible: true,
      submenu: [
        { lable: 'New Stock', path: 'rm-portal/new-stock', visible: true },
        { lable: 'Available Stock', path: '/rm-portal/available-stock', visible: false },
        { lable: 'Submitted Stock', path: '/rm-portal/submitted-stock', visible: false },
        { lable: 'Sold Stock', path: '/rm-portal/sold-stock', visible: true }
      ]
    },
    {
      lable: 'Sales',
      path: '/rm-portal/sales-history',
      visible: true,
      submenu: []
    },
    {
      lable: 'Udhar',
      path: '/rm-portal/udhar',
      visible: true,
      submenu: []
    },
    {
      lable: 'Accounts',
      path: '/rm-portal/incentive',
      visible: true,
      submenu: [
        { lable: 'Incentives', path: '/rm-portal/incentive', visible: true },
        { lable: 'Expenses list', path: '/rm-portal/expense', visible: true },
        { lable: 'Add Expenses *', path: '/rm-portal/add-expense', visible: true },
        { lable: 'Update Expenses *', path: '/rm-portal/edit-expense', visible: true },
        { lable: 'Assets', path: '/rm-portal/assets', visible: true },
      ]
    },
    {
      lable: 'Customer List',
      path: 'user-list/customer-list',
      visible: true,
      submenu: [
        { lable: 'Add Customer', path: '/create-user/add-customer', visible: true },
        { lable: 'Sell permission *', path: '/sell-details-lot', visible: true },
        { lable: 'Payment panel *', path: '/payment-details', visible: true, deletePermission: 'stock_outs_delete' }
      ]
    },
    {
      path: '/admin-panel', lable: 'Settings', visible: true,
      submenu: [
        { lable: 'Login and Sell *', path: '/admin-panel/set-type', visible: true },
        { lable: 'Add Category *', path: '/admin-panel/category-parent/add-category', visible: true, updatePermission: 'categories_update', deletePermission: 'categories_delete' },
        { lable: 'Subcategory *', path: '/admin-panel/category-parent/sub-category', visible: true, updatePermission: 'sub_categories_update', deletePermission: 'sub_categories_delete' },
        { lable: 'Assembly Brand *', path: '/admin-panel/category-parent/assembly_brand', visible: true, updatePermission: 'assembly_brands_update', deletePermission: 'assembly_brands_delete' },
        { lable: 'Customization *', path: '/admin-panel/dropdown-setting', visible: true },
        { lable: 'Karigar List *', path: '/admin-panel/list-kalakar', visible: true },
        { lable: 'Karigar Panel *', path: '/admin-panel/admin-kalakar', visible: true },
        { lable: 'Karigar Raw Materials *', path: '/raw-material-returned-list', visible: true },
        { lable: 'Rough Estimate *', path: '/admin-panel/rough-estimate-customization', visible: true },
        { lable: 'Assets *', path: '/admin-panel/asset-form', visible: true, updatePermission: 'assets_update', deletePermission: 'assets_delete' },
        { lable: 'Rate List *', path: '/admin-panel/rate-List', visible: true, updatePermission: 'rate_list_generator_update', deletePermission: 'rate_list_generator_delete' },
        { lable: 'Whatsapp Instance *', path: '/admin-panel/whatsapp-instance', visible: true },
        { lable: 'Add Expense Type *', path: '/admin-panel/expense-type', visible: true, updatePermission: 'expense_types_update', deletePermission: 'expense_types_delete' },
        { lable: 'Weighing Scale Setting *', path: '/admin-panel/weighing-scale-setting', visible: true }
      ]
    },
    // Added for Direct Cash/Metal by Pratik (24-06-2026)
    {
      lable: 'Direct Cash/Metal',
      path: '/direct-entry',
      visible: true,
      submenu: [
        { lable: 'Direct Entries List', path: '/direct-entry', visible: true, updatePermission: 'direct_entries_update', deletePermission: 'direct_entries_delete' },
      ]
    },
    // {
    //   path: '/invoice-gst-panel', lable: 'GST Firm', visible: true,
    //   submenu: [
    //     { lable: 'GST Invoice', path: '/invoice-gst-panel', visible: true },
    //     { lable: 'Purchase Bill', path: '/purchase-bill', visible: true },
    //     { lable: 'Purchase Bill Report', path: '/purchase-report', visible: true },
    //     { lable: 'GST Bill Report', path: '/gst-bill-report', visible: true },
    //     { lable: 'Customer List', path: '/gst-customer-list', visible: true },
    //     { lable: 'Settings', path: '/gst-settings', visible: true, },
    //     { lable: 'Invoice Customization', path: '/gst-settings/gst-inv-layout-settings', visible: true },
    //     { lable: 'Whatsapp Instance', path: '/gst-settings/whatsapp-instance', visible: true },
    //   ]
    // }
  ];

  constructor(
    private route: ActivatedRoute,
    private userStaffService: UserStaffService,
    private userAccessService: UserAccessService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.route.parent?.paramMap.subscribe(params => {
      const idString = params.get('staffId');

      if (!idString) {
        this.notificationService.showError('No User ID provided', 'Error');
        return;
      }

      this.activeUserId = Number(idString);

      console.log('✅ Staff ID:', this.activeUserId);

      this.fetchUserName();
      this.fetchPermissions();
    });
  }


  fetchUserName() {
    if (!this.activeUserId) return;
    this.userStaffService.getUserStaffById(this.activeUserId).subscribe({
      next: (res: any) => {
        this.activeUserName = res.data?.name || res.name || 'Unknown Staff';
        this.activeUserLastName = res.data?.user_last_name;
        this.activeUserImage = res.data?.documents?.[0]?.doc_user_img;
      },
      error: (err) => {
        console.error('Failed to fetch user details', err);
        this.activeUserName = 'Unknown User';
      }
    });
  }

  fetchPermissions() {
    if (!this.activeUserId) return;

    this.isLoading = true;

    // USE SERVICE
    this.userAccessService.getUserAccess(this.activeUserId).subscribe({
      next: (res: any) => {
        const data = res.data;
        if (data) {
          this.selectedMainPaths = data.mainmenu_visibility || [];
          this.selectedSubPaths = data.submenu_visibility || [];
          this.selectedUpdatePaths = data.update_access || [];
          this.selectedDeletePaths = data.delete_access || [];
        } else {
          this.selectedMainPaths = [];
          this.selectedSubPaths = [];
          this.selectedUpdatePaths = [];
          this.selectedDeletePaths = [];
        }
        this.isLoading = false;
        this.activeMenuIndex = 0;
        this.showMobileDetails = false;
      },
      error: (err) => {
        console.error('Error fetching permissions:', err);
        if (err.status === 401) {
          this.notificationService.showError('Unauthorized: Please Login Again.', 'Error');
        } else {
          this.notificationService.showError('Could not fetch permissions.', 'Error');
        }
        this.isLoading = false;
      }
    });
  }

  savePermissions() {
    if (!this.activeUserId) return;

    const isConfirmed = window.confirm(
      'Are you sure you want to save these permissions?'
    );

    if (!isConfirmed) {
      return;
    }

    const payload = {
      user_id: this.activeUserId,
      firm_id: 1,
      mainmenu_visibility: this.selectedMainPaths,
      submenu_visibility: this.selectedSubPaths,
      update_access: this.selectedUpdatePaths,
      delete_access: this.selectedDeletePaths
    };

    this.userAccessService.saveUserAccess(payload).subscribe({
      next: () => {
        this.notificationService.showSuccess(
          'Permissions saved successfully!',
          'Success'
        );
      },
      error: (err) => {
        console.error('Error saving:', err);

        if (err.status === 401) {
          this.notificationService.showError(
            'Unauthorized: Please login again.',
            'Error'
          );
        } else {
          this.notificationService.showError(
            'Failed to save permissions.',
            'Error'
          );
        }
      }
    });
  }

  // --- HELPER UI METHODS ---

  setActiveMenu(index: number) {
    this.activeMenuIndex = index;
    this.showMobileDetails = true;
  }

  backToMobileList() {
    this.showMobileDetails = false;
  }

  toggleMain(path: string, event: any) {
    const checked = event.target.checked;

    if (checked) {
      if (!this.selectedMainPaths.includes(path)) {
        this.selectedMainPaths.push(path);
      }
    } else {
      this.selectedMainPaths = this.selectedMainPaths.filter(p => p !== path);

      const mainMenu = this.navbarOptions.find(m => m.path === path);
      if (mainMenu && mainMenu.submenu?.length) {
        const submenuPaths = mainMenu.submenu.map(s => s.path);
        this.selectedSubPaths = this.selectedSubPaths.filter(p => !submenuPaths.includes(p));
      }
    }
  }

  isMainChecked(path: string): boolean {
    return this.selectedMainPaths.includes(path);
  }

  isSubChecked(path: string): boolean {
    return this.selectedSubPaths.includes(path);
  }

  // 🔹 Check if all submenus are checked
  areAllSubmenusChecked(submenus: MenuOption[] = []): boolean {
    if (!submenus.length) return false;
    return submenus.every(sub =>
      this.selectedSubPaths.includes(sub.path)
    );
  }

  // 🔹 Check if any submenu is checked
  isAnySubmenuChecked(submenus: MenuOption[] = []): boolean {
    return submenus.some(sub =>
      this.selectedSubPaths.includes(sub.path)
    );
  }

  // 🔹 Toggle single submenu (AUTO SYNC MAIN MENU)
  toggleSub(sub: MenuOption, event: any) {

    const activeItem = this.navbarOptions[this.activeMenuIndex];

    if (!activeItem) return;

    if (event.target.checked) {

      if (!this.selectedSubPaths.includes(sub.path)) {
        this.selectedSubPaths.push(sub.path);
      }
      // added by Pratik for staff also access the karigar route if they have the access in the admin panel
      if (sub.path === '/admin-panel/list-kalakar') {
        if (!this.selectedSubPaths.includes('/admin-panel/admin-kalakar')) {
          this.selectedSubPaths.push('/admin-panel/admin-kalakar');
        }
      }
      if (sub.path === '/admin-panel/admin-kalakar') {
        if (!this.selectedSubPaths.includes('/admin-panel/list-kalakar')) {
          this.selectedSubPaths.push('/admin-panel/list-kalakar');
        }
      }

      // 🔥 AUTO ADD UPDATE ACCESS
      if (
        sub.updatePermission &&
        !this.selectedUpdatePaths.includes(sub.updatePermission)
      ) {
        this.selectedUpdatePaths.push(sub.updatePermission);
      }

    } else {

      this.selectedSubPaths =
        this.selectedSubPaths.filter(
          p => p !== sub.path
        );
      // added by Pratik for staff also access the karigar route if they have the access in the admin panel
      if (sub.path === '/admin-panel/list-kalakar') {
        this.selectedSubPaths = this.selectedSubPaths.filter(p => p !== '/admin-panel/admin-kalakar');
      }
      if (sub.path === '/admin-panel/admin-kalakar') {
        this.selectedSubPaths = this.selectedSubPaths.filter(p => p !== '/admin-panel/list-kalakar');
      }

      // REMOVE UPDATE
      if (sub.updatePermission) {
        this.selectedUpdatePaths =
          this.selectedUpdatePaths.filter(
            p => p !== sub.updatePermission
          );
      }

      // REMOVE DELETE
      if (sub.deletePermission) {
        this.selectedDeletePaths =
          this.selectedDeletePaths.filter(
            p => p !== sub.deletePermission
          );
      }
    }

    // AUTO MAIN MENU

    const anyChecked =
      this.isAnySubmenuChecked(
        activeItem.submenu || []
      );

    const mainPath = activeItem.path;

    if (
      anyChecked &&
      !this.selectedMainPaths.includes(mainPath)
    ) {
      this.selectedMainPaths.push(mainPath);
    }

    if (!anyChecked) {

      this.selectedMainPaths =
        this.selectedMainPaths.filter(
          p => p !== mainPath
        );
    }
  }

  // 🔹 Select All / Deselect All (AUTO SYNC MAIN)
  toggleAllSubmenus(submenus: MenuOption[], event: any) {
    const activeItem = this.navbarOptions[this.activeMenuIndex];
    if (!activeItem) return;

    const mainPath = activeItem.path;

    if (event.target.checked) {
      // Select all submenus
      submenus.forEach(sub => {
        if (!this.selectedSubPaths.includes(sub.path)) {
          this.selectedSubPaths.push(sub.path);
        }
      });

      // Select main menu
      if (!this.selectedMainPaths.includes(mainPath)) {
        this.selectedMainPaths.push(mainPath);
      }
    } else {
      // Remove all submenus
      const submenuPaths = submenus.map(s => s.path);
      this.selectedSubPaths = this.selectedSubPaths.filter(
        p => !submenuPaths.includes(p)
      );

      // Remove main menu
      this.selectedMainPaths = this.selectedMainPaths.filter(p => p !== mainPath);
    }
  }

  // 🔹 Toggle update access
  toggleUpdate(permission: string | undefined, event: any) {

    if (!permission) return;

    if (event.target.checked) {

      if (!this.selectedUpdatePaths.includes(permission)) {

        this.selectedUpdatePaths.push(permission);
      }

    } else {

      this.selectedUpdatePaths =
        this.selectedUpdatePaths.filter(
          p => p !== permission
        );
    }
  }

  // 🔹 Toggle delete access
  toggleDelete(permission: string | undefined, event: any) {

    if (!permission) return;

    if (event.target.checked) {

      if (!this.selectedDeletePaths.includes(permission)) {

        this.selectedDeletePaths.push(permission);
      }

    } else {

      this.selectedDeletePaths =
        this.selectedDeletePaths.filter(
          p => p !== permission
        );
    }
  }

  isUpdateChecked(permission?: string): boolean {

    if (!permission) return false;

    return this.selectedUpdatePaths.includes(permission);
  }

  isDeleteChecked(permission?: string): boolean {

    if (!permission) return false;

    return this.selectedDeletePaths.includes(permission);
  }
  // 🔹 Check if action permissions (update/delete) should be shown for a path
  shouldShowActionPermissions(path: string): boolean {
    return path.startsWith('/report') ||
      path.startsWith('/packaging') ||
      path.startsWith('/invoice-report') ||
      path.startsWith('/user-list') ||
      path.startsWith('/taggings-list') ||
      path.startsWith('/raw-metal') ||
      path.startsWith('/accounts') ||
      path.startsWith('/admin-panel') ||
      path.startsWith('/direct-entry') ||
      path.startsWith('/payment-details') ||
      path === '/product-creation'
  }
}